<template>
	<vs-row>
		<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="7" vs-sm="12" vs-lg="7">
		    <Default :index="index"></Default>
		 </vs-col>
		 <vs-col class="px-6"  vs-type="flex" vs-justify="center" vs-align="center" vs-w="5" vs-sm="12" vs-lg="5">
		     <DefaultSelect class="mr-3" :index="index" :label="$t('MODULE.typePassword')"></DefaultSelect>
		  </vs-col>
	</vs-row>	
</template>

<script type="text/javascript">
	import Default from './Default.vue';
	import DefaultSelect from '../../componentsToQuestions/DefaultSelect.vue';
	export default {
		props: ['index'],
		components: { Default, DefaultSelect }

	}
</script>